import { useTranslation } from "react-i18next";
import { AlarmClock, CalendarCheck, Clock, TimerReset } from "lucide-react";
import { StatCard } from "../../components/neu/StatCard";

export const LogSummary = ({ records }) => {
  const { t } = useTranslation();
  const worked = records.reduce((sum, r) => sum + (r.worked_minutes || 0), 0);
  const overtime = records.reduce((sum, r) => sum + (r.overtime_minutes || 0), 0);
  const late = records.filter((r) => (r.late_minutes || 0) > 0).length;

  // نغمات زاهية دلالية: أيام مسجلة أخضر، ساعات العمل أزرق، إضافي بنفسجي، تأخير كهرماني.
  const cards = [
    { key: "days",     value: records.length,           icon: CalendarCheck, tone: "emerald" },
    { key: "hours",    value: (worked / 60).toFixed(1), icon: Clock,         tone: "sky" },
    { key: "overtime", value: (overtime / 60).toFixed(1), icon: TimerReset,  tone: "violet" },
    { key: "lateDays", value: late,                     icon: AlarmClock,    tone: "amber" },
  ];

  return (
    <div className="grid grid-cols-2 gap-4 lg:grid-cols-4" data-testid="log-summary">
      {cards.map((c) => (
        <StatCard
          key={c.key}
          testId={`log-${c.key}`}
          label={t(`log.${c.key}`)}
          value={c.value}
          icon={c.icon}
          tone={c.tone}
        />
      ))}
    </div>
  );
};
